import React from 'react';

export const insertPlainTextFromClipboard = (event: React.ClipboardEvent<HTMLDivElement>) => {
	event.preventDefault();
	const text = event.clipboardData.getData('text/plain');
	document.execCommand('insertText', false, text);
};

export const normalizeSingleLineEditableText = (text: string): string => text.replace(/\r?\n/g, ' ').trimStart();

export const setEditableText = (element: HTMLDivElement | null, value: string) => {
	if (!element || document.activeElement === element || element.innerText === value) return;
	element.innerText = value;
};

export const clearEmptyEditable = (element: HTMLDivElement | null) => {
	if (!element) return;
	const text = element.innerText;
	if (text === '' || text === '\n') element.innerHTML = '';
};
